import { render, staticRenderFns } from "./TableCol.vue?vue&type=template&id=6f29903d&scoped=true"
import script from "./TableCol.vue?vue&type=script&lang=js"
export * from "./TableCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f29903d",
  null
  
)

export default component.exports